import React, { useContext, useEffect, useRef, useState } from 'react'
import Breadcrumbs from '../Breadcrumb';
import { LoaderContext } from '../../AuthContext/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { customSelectStyles } from '../../middlewares/Utils';
import { Tooltip } from '@mui/material';
import Select from "react-select";
import PujaListCard from './PujaListCard';
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import NoResultFoundModel from '../NoDataFound/NoDataFoundModal';

const PujasListPage = () => {
    const { setLoader, loader } = useContext(LoaderContext);
    const user_id = localStorage.getItem("userID");
    const location = useLocation();
    const navigate = useNavigate();
    const categoryListRef = useRef(null);
    const productListRef = useRef(null);

    const [totalRecords, setTotalRecords] = useState(0)
    const [isMobile, setIsMobile] = useState(false);
    const [pujaListData, setPujaListData] = useState([]);
    const [catID, setCatID] = useState(null);
    const [selectedCatId, setSelectedCatId] = useState(null);
    const [categoryList, setCategoryList] = useState([])
    const [search, setSearch] = useState("");


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const viewDetail = (product) => {
        const newSlug = product?.PujaSlug;
        if (catID) {
            sessionStorage.setItem("selectedCatId", catID);
        }
        navigate(`/services/book-puja/${newSlug}`, {
            state: { product: product, PujaStatus: 2 },
        });
    };
    return (
        <>
            <section className="page-header" style={{ height: isMobile && "225px" }}>
                <div className="page-header__bg"></div>
                <div className="container">
                    <h2 className="page-header__title bw-split-in-left">Book Puja</h2>
                </div>
            </section>

            <div className="main py-4">
                <div className="container px-3 px-md-4">
                    <div className="row gx-4 gy-4">
                        <div className="breadcrumbMobile" style={{ padding: "8px" }}>
                            <Breadcrumbs />
                        </div>

                        {!isMobile ? (
                            <div className="left col-md-3 col-sm-4">

                                <div>
                                    <h4
                                        className="custom-list-item clearfix"
                                        style={{
                                            fontFamily: "Bricolage Grotesque",
                                            fontSize: "20px",
                                            borderBottom: "1px solid lightgray",
                                            textTransform: "none",
                                            padding: "12px",
                                        }}
                                    >
                                        Puja Category
                                    </h4>

                                    {/* Scrollable wrapper */}
                                    <div
                                        ref={categoryListRef}

                                        className="scrollable-category"
                                        style={{
                                            maxHeight:
                                                pujaListData?.length <= 6
                                                    ? "25em"
                                                    : pujaListData?.length <= 10
                                                        ? "50em"
                                                        : pujaListData?.length <= 25
                                                            ? "90em"
                                                            : pujaListData?.length <= 45
                                                                ? "120em"
                                                                : "150em",
                                            overflowY: "auto",
                                            paddingRight: "5px",
                                        }}



                                    >
                                        <ul className="margin-bottom-25 sidebar-menu list-unstyled">
                                            {categoryList?.length > 0 ? (
                                                categoryList.map((category, index) => (
                                                    <li className="list-group-item clearfix" key={index}>
                                                        <Link
                                                            to="#"
                                                            // onClick={() => handleCatChange(category)}
                                                            className={`d-flex align-items-center ${selectedCatId === category.PUJACAT_ID ? "active" : ""}`}
                                                            style={{ textWrap: "nowrap" }}
                                                        >
                                                            <i className="fa fa-angle-right me-2"></i>
                                                            {category.PUJACAT_NAME?.length > 30 ? (
                                                                <Tooltip title={category.PUJACAT_NAME}>
                                                                    {`${category.PUJACAT_NAME.substring(0, 19)}...`}
                                                                </Tooltip>
                                                            ) : (
                                                                category.PUJACAT_NAME
                                                            )}
                                                        </Link>
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="list-group-item">No categories available</li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <Select
                                styles={customSelectStyles}
                                options={categoryList}
                                placeholder="Select Category"
                                value={categoryList.find(
                                    (option) => option.value === catID
                                )}
                                onChange={(selectedOption) => {
                                    setCatID(selectedOption.value);
                                    setSelectedCatId(selectedOption.value);
                                }}
                            />
                        )}

                        {/* Product List */}
                        <div className="right col-md-9 col-sm-8 ">
                            {pujaListData?.length !== 0 ? (
                                <div
                                    className="row w-100"
                                    style={{ justifyContent: "flex-start" }}
                                    ref={productListRef}
                                >
                                    {pujaListData
                                        ?.filter(
                                            (product) =>
                                                search === "" ||
                                                product.PUJA_NAME.toLowerCase().includes(search.toLowerCase())
                                        )
                                        .map((product) => (
                                            <PujaListCard
                                                key={product.PUJA_ID}
                                                product={product}
                                                viewDetail={viewDetail}
                                                // placeholderImg={placeholderImg}
                                                isMobile={isMobile}
                                            />
                                        ))}
                                </div>
                            ) : ""}
                            {totalRecords <= 0 && (
                                <NoResultFoundModel totalRecords={totalRecords} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PujasListPage
